<template>
  <div class="container-fluid mb-5">
    <div class="row">
      <div class="col-12 p-0">
        <img src="../assets/imgs/薩爾達傳說-曠野之息/1.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
